import styled from 'styled-components';
import { NodeTilePanel } from 'ui/workflows/nodeTilePanel';

export const NodeTilePanelStyled = styled(NodeTilePanel)`
  height: 100%;
`;
